<template>
  <div class="footer">
  
      <div class="footerbottom clear">
           <div class="footer_left">
               <div class="footer_logo"><img src="../../assets/image/bottom-logo.png"/></div>
               <div class="footer_title">AI赋能，驱动商业进化</div>
               <p>咨询电话：0571-28179999</p>
               <p>市场合作：186 6790 8789</p>
           </div>
           <div class="footer_right">
              <i><img src="../../assets/image/img_1_wechat.png"/></i>
              <p>官方微信</p>
           </div>
      </div>
      <div class="footerRemark">
         <span>Copyright@2018 浙ICP备18013532号-1 
           <br/> 
           版权所有 杭州智语网络科技有限公司</span>
      </div>
      <div class="footerFloat">
        <ul>
          <li class='li_1'>
             <a href="http://p.qiao.baidu.com/cps/chat?siteId=12255765&userId=25480887">
                <img src="../../assets/image/icon_onlineconsultation.png" />
                <p>在线咨询</p>
             </a>
          </li>
          <li class='li_2'>
             <a href="tel:\\0571-28179999">
                <img src="../../assets/image/icon_tel.png" />
                <p>电话咨询</p>
             </a>
          </li> 
          <li class='li_3' @click="popup">
             <img src="../../assets/image/icon_freetrial.png" />
             <p class="pte">免费体验</p>
          </li> 
        </ul>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      
    }
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    }
  }
}
</script>


<style scoped>
.footerFloat{
  width:100%;
  position:fixed;
  left:0px;
  bottom:0px;
  height:1rem;
 
  z-index:99;
}
.footerFloat ul{
  overflow:hidden;
  width:100%;
  background:#f6f6f6;
}
.footerFloat ul li{
  float:left;
  width:30%;
  /*width:33.2%;*/
  height:1rem;
  border-left:1px solid #ccc; 
   border-top:1px solid #ccc;
  margin-left:-1px;
  background:#f6f6f6;
}
.footerFloat ul li:last-child{
  width:40%;
  background:#307EFF; 
   border-top:none; 
}
.footerFloat ul li a{
  display:block;
  width:100%; 
  height:100%;
  float: left;
}
.footerFloat ul li img{

  text-align:center;
  color:#5395e6;
  margin:0 auto;
  display:block;
}
.footerFloat ul li.li_1 img{
    width:0.43rem; 
    height:0.36rem; 
    margin-top:0.14rem;
}
.footerFloat ul li.li_2 img{
    width:0.43rem; 
    height:0.39rem; 
    margin-top:0.12rem;
}
.footerFloat ul li.li_3{
    overflow:hidden;

}
.footerFloat ul li.li_3 img{
    float:left;
    width:0.42rem; 
    height:0.36rem; 
    margin:0.31rem 0.17rem 0 0.6rem;
}
.footerFloat ul li.li_3 p{
    font-size:0.24rem;
    color:#F6F9FE;
    margin-top:0.31rem;
    text-align:left;
}
.footerFloat ul li p{
  text-align:center;
  color:#666666;
  font-size:0.24rem;
  line-height:0.36rem;
}
.footerFloat ul li p.pte{
    font-size:0.28rem;
    letter-spacing: 2px;
}
.footerFloat ul li p:first-child{
  color:#fff;
  line-height:1rem;
}
.footer{
  width:100%;
  padding-bottom:1rem;
}
.footerbottom{
  background:#061431;
  padding:0.5rem;
}
.footerbottom .footer_left{
  float:left;

}
.footerbottom .footer_left .footer_logo{
    width:1.47rem;
    height:0.47rem;
}
.footerbottom .footer_left .footer_logo img{
    width:1.47rem;
    height:0.47rem;
    display:block;
}
.footerbottom .footer_left .footer_title{
   font-size:0.22rem;
   color:#fff;
   margin-top:0.14rem;
   margin-bottom:0.14rem;
}
.footerbottom .footer_left p{
    font-size:0.2rem;
    opacity:0.9;
    color:#fff;
    line-height:0.4rem;
}
.footerbottom .footer_right{
  float:right;

}
.footer_right i{
  display:block;
  width:1.41rem;
  height:1.4rem;
  margin-top:0.05rem;
}
.footer_right i img{
  display:block;
  width:1.41rem;
  height:1.4rem;
}
.footer_right p{
  color:#fff;
  margin-top:0.2rem;
  text-align:center;
}
.footerRemark{
  background:#1e2c46;
}
.footerRemark span{
  display:block;
  color:#fff;
  font-size:0.16rem;
  opacity:0.7;
  text-align:center;
}
</style>




// WEBPACK FOOTER //
// src/components/public/footerbar.vue